import React, { useEffect } from 'react';
import {Route,BrowserRouter,Switch} from 'react-router-dom';
import Home from './components/Home';
import Products from './components/Products';
import ScrollToTop from './components/ScrollToTop';
import BackToTopButton from './components/BackToTopButton';
import NavbarComp from './components/Navbar';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Privacypolicy from './components/Privacypolicy';
import Termsofuse from './components/Termsofuse';
import Productdetailsobs from './components/Productdetailsobs';
import Productsframe from './components/Productsframe';
import Productsnoanimation from './components/Productsnoanimation';
import Productsframer from './components/Productsframer';


const App = () => {

  return (
    <BrowserRouter>
    <>
   
    <ScrollToTop />
      
      <NavbarComp />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/products" component={Productsframe} />
        <Route path="/productsframer" component={Productsframer} />
        <Route path="/productsobs" component={Productdetailsobs} />
        <Route path="/productsnoanimation" component={Productsnoanimation} />
        <Route path="/productswitheffects" component={Products} />
        <Route path="/privacy-policy" component={Privacypolicy} />
        <Route path="/terms-of-use" component={Termsofuse} />
        
      </Switch>
    </>
    
    <BackToTopButton />
    </BrowserRouter>
  )
}

export default App


